import React, { useState } from 'react';
import App from '../App';
import SplashPage from './SplashPage';
import PasswordAuth from './PasswordAuth';

type AppState = 'splash' | 'auth' | 'app';

const AppWithSplash: React.FC = () => {
  const [appState, setAppState] = useState<AppState>('splash');

  const handleEnterFromSplash = () => {
    setAppState('auth');
  };

  const handleAuthenticated = () => {
    setAppState('app');
  };

  const handleBackToSplash = () => {
    setAppState('splash');
  };

  switch (appState) {
    case 'splash':
      return <SplashPage onEnter={handleEnterFromSplash} />;
    case 'auth':
      return (
        <PasswordAuth
          onAuthenticated={handleAuthenticated}
          onBack={handleBackToSplash}
        />
      );
    case 'app':
      return <App />;
    default:
      return <SplashPage onEnter={handleEnterFromSplash} />;
  }
};

export default AppWithSplash;
